<script setup lang="ts">
import type { FilterCategory, FilterDraft, FilterToggle } from '#shared/mobile-filter-drawer'
import { faBookmark, faBooks, faBuildingColumns, faPenNib } from '@fortawesome/pro-light-svg-icons'

const openFilter = defineModel('openFilter', { default: false })

const { typeFilter, legalAreaFilter, authorFilter, showOnlyFavorites, typeOptions, legalAreaOptions, authorOptions, countWithFilters } = useLiteratureFilters()

const categories = computed<FilterCategory[]>(() => [
  { id: 'type', label: 'Type litteratur', icon: faBooks, options: typeOptions.value, resetAriaLabel: 'Nullstill type litteratur' },
  { id: 'rettsområde', label: 'Rettsområde', icon: faBuildingColumns, options: legalAreaOptions.value, resetAriaLabel: 'Nullstill rettsområde' },
  { id: 'forfatter', label: 'Forfatter', icon: faPenNib, options: authorOptions.value, resetAriaLabel: 'Nullstill forfatter' },
])

const toggles = computed<FilterToggle[]>(() => [
  { id: 'favoritter', label: 'Favoritter', icon: faBookmark },
])

const initial = computed<FilterDraft>(() => ({
  categories: {
    type: typeFilter.value,
    rettsområde: legalAreaFilter.value,
    forfatter: authorFilter.value,
  },
  toggles: { favoritter: showOnlyFavorites.value },
}))

function count(draft: FilterDraft) {
  return countWithFilters({
    typeFilter: draft.categories.type ?? [],
    legalAreaFilter: draft.categories.rettsområde ?? [],
    authorFilter: draft.categories.forfatter ?? [],
    showOnlyFavorites: draft.toggles.favoritter ?? false,
  })
}

function onCommit(draft: FilterDraft) {
  typeFilter.value = [...(draft.categories.type ?? [])]
  legalAreaFilter.value = [...(draft.categories.rettsområde ?? [])]
  authorFilter.value = [...(draft.categories.forfatter ?? [])]
  showOnlyFavorites.value = draft.toggles.favoritter ?? false
}
</script>

<template>
  <MobileFilterDrawer
    v-model:open="openFilter"
    :categories="categories"
    :toggles="toggles"
    :initial="initial"
    :count="count"
    :min-height="60"
    @commit="onCommit"
  />
</template>
